<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <div class="w-100 mt-3">
    @if(!readOnly){
      <form [formGroup]="selectForm" class="flex-row flex-wrap space-between">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-select placeholder="Select Portfolio" formControlName="portfolio">
            @for (portfolio of portfolioArray; track $index) {
              <mat-option [value]="portfolio">
                {{portfolio.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button mat-icon-button color="primary" (click)="onAddPortfolio()" class="mb-4" matTooltip="Add new portfolio"><mat-icon>add_circle</mat-icon></button>
      </form>
    }
    @else{
      <div class="text-lg mb-3">{{portfolio?.name}}</div>
    }
    @if(selectedPortfolio?.propertyAbstracts?.length==0){
      No properties in this portfolio.
    }
    @else if(selectedPortfolio?.propertyAbstracts){
      @for (pa of selectedPortfolio?.propertyAbstracts; track $index; let i = $index; let first = $first) {
        @if(!first){<div class="list-separator"></div>}
        <app-property-abstract [propertyAbstract]="pa" [disabled]="false" [readonly]="true" (click)="onPropertyAbstractClick(pa)" (propertyIdClick)="onPropertyIdClick(pa)" class="w-100"></app-property-abstract>
      }
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions >
  <div class="w-100 flex-row space-between items-center mt-3">
    @if(!readOnly){<button [disabled]="!canSubmit" mat-flat-button class="w-33" color="primary" (click)="onConfirmClick()" tabindex="2" >{{confirmButtonText}}</button>}
    @else{<span></span>}
    <button class="w-33" mat-flat-button color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
  </div>
</mat-dialog-actions>

